import React, { FC } from 'react'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'
import { SpotBiddingRule } from 'apps/marketplace/apiTypes/spotBiddingConfigs'
import { StrikePriceRule } from './StrikePriceRule'

const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: theme.spacing(2),
  },
  rulesContainer: {
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    borderLeft: `1px solid ${brandColors.coolGray4}`,
  },
}))

interface IStrikePriceRuleCollectionProps {
  label: string
  rules: SpotBiddingRule[]
  ruleEditHandler: (rule?: SpotBiddingRule) => void
  ruleDeleteSuccessHandler: () => void
}

export const StrikePriceRuleCollection: FC<IStrikePriceRuleCollectionProps> = ({
  label,
  ruleDeleteSuccessHandler,
  ruleEditHandler,
  rules,
}) => {
  const classes = useStyles()
  if (label === 'Lane') {
    rules = rules.sort((a, b) => {
      const pickupComparison = (a.laneGeographicCriteria?.pickupValue ?? '').localeCompare(
        b.laneGeographicCriteria?.pickupValue ?? ''
      )
      if (pickupComparison !== 0) {
        return pickupComparison
      }
      return (a.laneGeographicCriteria?.deliveryValue ?? '').localeCompare(
        b.laneGeographicCriteria?.deliveryValue ?? ''
      )
    })
  }
  return (
    <Box className={classes.container}>
      <Box mb={1}>
        <Typography variant='overline'>{label}</Typography>
      </Box>
      <Box className={classes.rulesContainer}>
        {rules.map(rule => (
          <StrikePriceRule
            key={rule.id}
            rule={rule}
            ruleEditHandler={ruleEditHandler}
            ruleDeleteSuccessHandler={ruleDeleteSuccessHandler}
          />
        ))}
      </Box>
    </Box>
  )
}
